import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { IdName } from 'src/core/models';
import { 
  AuthService, FestivalUserService, ChurchService, 
  AgeGroupService, ArrayService, DatabaseService 
} from 'src/core/services';
import { NgForm } from '@angular/forms';
import { ModalController } from '@ionic/angular';
import { PageClass } from 'src/core/classes/page';

@Component({
  selector: 'app-add-church',
  templateUrl: './add-church.component.html',
  styleUrls: ['./add-church.component.less', '../../core/styles/common.less']
})

export class AddChurchComponent extends PageClass implements OnInit {

  church: any = {
    isActive : true,
    isDeleted : false,
    isInterstate : false
  };

  countryList: IdName[];
  stateList: IdName[];

  @ViewChild('addChurchForm', null) addChurchForm: NgForm;
  @ViewChild('closeModal', null)  closeModal: ElementRef;

  constructor(
    protected ageGroupService: AgeGroupService,
    protected arrayService: ArrayService,
    protected authService: AuthService,
    protected churchService: ChurchService,
    protected databaseService: DatabaseService,
    protected festivalUserService: FestivalUserService,
    private modalController: ModalController
  ) {
    super(ageGroupService, arrayService, authService, churchService, databaseService, festivalUserService);
  }

  // ngOnInit() {
  //   /* Check if user is LoggedIn */

  //   // TODO: Use Guarc
  //   this.loadData();

  //   //this.validateCurrentUser();
  // }

  // private async validateCurrentUser() {
  //   const systemUser = await this.authService.getLoggedInUser();
  //   if (systemUser) {
  //     this.currentUserId = systemUser.uid;
      
  //   } else {
  //     this.dismissModal();
  //   }
  // }

  protected loadData = async () => {
      // this.currentUser = this.festivalUserService.GetCurrentFestivalUser();
      if (this.currentUser.isActive && !this.currentUser.isDeleted) {
        this.countryList = this.churchService.getCountryList();
        this.stateList = this.churchService.getAustraliaStateList();
      } else {
        this.dismissModal();
      }
  }

  ResetState = () => {
    this.church.state = undefined;
  }

  public async addChurch() {
    if (this.addChurchForm.invalid) {
      return;
    }

    if (this.church.country.id !== 'AU') {
      this.church.state = null;
    }

    if (!this.church.state || this.church.state.id !== 'VIC') {
      this.church.isInterstate = true;
    }

    await this.churchService.createChurch(this.church)
      .then (() => {
        alert('Church Successfully Created');
    
        this.dismissModal();
      });
  }

  dismissModal() {
    this.modalController.dismiss();
  }
}
